export default __webpack_public_path__ + "static/home1-a0a586b1abc9d85f5c6a0bc76e478831.jpg";